var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 6.16L11 0L0 6.16L2.2 7.38737V11.3937C1.76 11.4863 1.41263 11.88 1.41263 12.3432C1.41263 12.6211 1.52842 12.8758 1.73684 13.0611L1.41263 15.9095C1.41263 15.9095 1.76 16.1411 2.38526 16.1411C3.01053 16.1411 3.35789 15.9095 3.35789 15.9095L3.03368 13.0611C3.21895 12.8758 3.35789 12.6211 3.35789 12.3432C3.35789 11.88 3.03368 11.4863 2.57053 11.3937V7.59579L4.21474 8.52211V6.94737C4.21474 5.69684 7.71158 5.00211 11 5.00211C14.2884 5.00211 17.7853 5.67368 17.7853 6.94737V8.52211L22 6.16Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9999 10.3745C7.22521 10.3745 4.58521 11.185 4.58521 11.9261C4.58521 12.6671 7.22521 13.4777 10.9999 13.4777C14.7747 13.4777 17.4147 12.6671 17.4147 11.9261C17.4147 11.2082 14.7747 10.3745 10.9999 10.3745Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.9999 5.39551C7.22521 5.39551 4.58521 6.20603 4.58521 6.94709V11.2545C5.58099 10.4439 8.35994 10.0039 10.9999 10.0039C13.6399 10.0039 16.4189 10.4439 17.4147 11.2545V6.94709C17.4147 6.20603 14.7747 5.39551 10.9999 5.39551Z",
    fill: "#8D90A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.1e23ac74c82541f04bd906a19e5c861d.svg";
export { ForwardRef as ReactComponent };